import React, { memo } from "react";
import PropTypes from "prop-types";
import FormGroup from "@mui/material/FormGroup";
import { ErrorMessage } from "../../Notifications";
import { StyledInputGroup } from "./styled";

const InputGroupBase = ({ error, children, extraClasses = "" }) => {
  return (
    <StyledInputGroup className={extraClasses}>
      <FormGroup row className="selectCombined">
        {children}
      </FormGroup>
      {error && <ErrorMessage error={error} />}
    </StyledInputGroup>
  );
};

InputGroupBase.propTypes = {
  error: PropTypes.string,
  children: PropTypes.node,
  extraClasses: PropTypes.string
};

export const InputGroup = memo(InputGroupBase);
